import { defineRecipe } from "@pandacss/dev";

export const aromaSkeleton = defineRecipe({
  className: "aroma-skeleton",
  jsx: ["Skeleton"],
  base: {
    width: "xl",
    height: "xl",
    backgroundColor: "background.decorative.neutral.base-subtle",
    backgroundImage:
      "linear-gradient(90deg, transparent, {colors.background.decorative.neutral.hover-subtle}, {colors.background.decorative.neutral.hover-subtle}, transparent)",
    backgroundSize: "200% 100%",
    backgroundRepeat: "no-repeat",
    animation: "3000ms linear infinite skeletonLoading",
    cursor: "default",
    pointerEvents: "none",
    userSelect: "none",
  },
  variants: {
    shape: {
      shape: {
        clipPath: "url(#clipShape)",
        height: "var(--skeleton-size, {sizes.xl})",
        width: "var(--skeleton-size, {sizes.xl})",
        "& svg": {
          width: "100%",
          height: "100%",
        },
      },
      square: {
        borderRadius: "l",
      },
      pill: {
        borderRadius: "pill",
      },
    },
  },
  defaultVariants: {
    shape: "square",
  },
});
